import { COMMUNITY_NAME_MAX_LENGTH, COMMUNITY_DEFAULT_LOGO_URL } from "Config";

export const getCommunityDisplayName = community => {
  return (
    community.abbreviation ||
    (community.name.length <= COMMUNITY_NAME_MAX_LENGTH
      ? community.name
      : community.name.substring(0, COMMUNITY_NAME_MAX_LENGTH) + " ...")
  );
};

export const getCommunityLogoUrl = community => {
  return community && community.avatarUrl
    ? community.avatarUrl
    : COMMUNITY_DEFAULT_LOGO_URL;
};

export const isSuperAdminAccess = (loggedAs, spaceAs) => {
  return loggedAs === "SUPERADMIN" && spaceAs === "SUPERADMIN";
};

export const isAdminAccess = (loggedAs, spaceAs) => {
  return loggedAs === "ADMIN" && spaceAs === "ADMIN";
};

export const isManagerAccess = (loggedAs, spaceAs) => {
  return loggedAs === "MANAGER" && spaceAs === "MANAGER";
};

export const isCollaboratorAccess = (loggedAs, spaceAs) => {
  return (
    loggedAs === "COLLABORATOR" ||
    (loggedAs === "MANAGER" && spaceAs === "COLLABORATOR")
  );
};

export const isSupervisorAccess = loggedAs => {
  return loggedAs === "SUPERVISOR";
};



// WEBPACK FOOTER //
// ./src/utils/community.js